import React, { useEffect, useState, useMemo, useRef } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { Loader } from '../Widgets';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import ArthaGateway from 'service/ArthaGateway';
import { ProductStyle } from 'service';
import defaultImage from "../../assets/default.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/pagination";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';


export const Product = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const { id } = useParams();
    const productId = id ? parseInt(id) : 0;
    const COMPANY_WHATSAPP = process.env.REACT_APP_COMPANY_WHATSAPP || "919611724989";
    const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME || "Paras Door";

    const [product, setProduct] = useState<any>();
    const [productStyles, setProductStyles] = useState<ProductStyle[]>([]);
    const [styleName, setStyleName] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    const [showFullscreen, setShowFullscreen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
    const [selectedGroup, setSelectedGroup] = useState<string>("");

    const galleryRef = useRef<any>(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!productId) return;

        Promise.all([
            ArthaGateway.getProductMaster(productId),
            ArthaGateway.getProductStyles(productId)
        ])
            .then(([prod, styles]) => {
                setProduct(prod);
                setProductStyles(styles);
            })
            .finally(() => setIsLoading(false));
    }, [productId]);

    const styleGroups = useMemo(() => {
        const filtered = productStyles.filter(s => s.name.toLowerCase().includes(styleName.toLowerCase()));
        return filtered.reduce((groups, style) => {
            const group = style.groupName?.trim() || "Other Styles";
            if (!groups[group]) groups[group] = [];
            groups[group].push(style);
            return groups;
        }, {});
    }, [productStyles, styleName]);

    const whatsappMessage = encodeURIComponent(
        `Hello, I would like to enquire about the product: ${product?.name}`
    );
    const whatsappLink = `https://wa.me/?text=${whatsappMessage}`;

    const pageUrl = encodeURIComponent(window.location.href);

    return (
        <div className="container py-4 page-product-detail">

            {isLoading && <Loader />}

            {!isLoading && (
                <>
                    <h2 className="fw-bold text-dark mb-3">{product?.name}</h2>

                    {product?.options?.length > 0 && (
                        <div className="card shadow-sm mb-4">
                            <div className="card-body">
                                <h5 className="fw-semibold mb-3">Product Specifications</h5>

                                {product.options.map((option, i) => (
                                    <div key={i} className="mb-2">
                                        <strong className="text-dark">{option.name}:</strong><br />
                                        <span className="ms-2 text-secondary">{option.values.join(", ")}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}


                    {/* Action Buttons */}
                    <div className="d-flex flex-column align-items-center gap-2 mt-4 mb-4">

                        <a
                            href={`https://wa.me/?text=${encodeURIComponent(
                                `Product: *${product?.name}*\nFor details: ${window.location.href}`
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-dark w-75"
                        >
                            <FontAwesomeIcon icon={faWhatsapp} className='me-2' /> Share via WhatsApp
                        </a>

                        {/*<button
                            className="btn btn-dark w-75"
                            type="button"
                            onClick={() => {
                                const message = encodeURIComponent(
                                    `Hello, I would like to enquire about the product: *${product?.name}*`
                                );
                                window.open(`https://wa.me/${COMPANY_WHATSAPP}?text=${message}`, "_blank");
                            }}
                        >
                            ✨ Enquire Now
                        </button> */}

                        <NavLink className="btn btn-outline-secondary w-75" to="/products">
                            ← Back to All Products
                        </NavLink>

                    </div>

                    {/* Style Search 
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control shadow-sm"
                            placeholder="Search style..."
                            value={styleName}
                            onChange={(e) => setStyleName(e.target.value)}
                        />
                    </div>*/}

                    {/* Full-screen gallery wrapper */}
                    <div ref={galleryRef} id="lightgallery">

                        {/* Styles Accordion */}
                        <div className="accordion" id="stylesAccordion">
                            {Object.keys(styleGroups).map((group, idx) => (
                                <div className="accordion-item" key={group}>
                                    <h2 className="accordion-header" id={`heading-${idx}`}>
                                        <button
                                            className={`accordion-button ${idx !== 0 ? "collapsed" : ""}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse-${idx}`}
                                        >
                                            {group} ({styleGroups[group].length})
                                        </button>
                                    </h2>

                                    <div
                                        id={`collapse-${idx}`}
                                        className={`accordion-collapse collapse ${idx === 0 ? "show" : ""}`}
                                        data-bs-parent="#stylesAccordion"
                                    >
                                        <div className="accordion-body">
                                            <div className="row g-3">
                                                <div className="row g-3">
                                                    {styleGroups[group].map((style, i) => (
                                                        <div
                                                            key={i}
                                                            className="col-6 col-md-4 col-lg-3"
                                                            onClick={() => {
                                                                setSelectedGroup(group);
                                                                setActiveIndex(i);
                                                                setShowFullscreen(true);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <div className="card shadow-sm border-0 h-100 p-2 image-hover-zoom">
                                                                <img
                                                                    src={style?.imageUrl || defaultImage}
                                                                    alt={style.name}
                                                                    className="img-fluid rounded"
                                                                    loading="lazy"
                                                                />
                                                                <div className="card-body p-2">
                                                                    <div className="card-title text-center small">
                                                                        {style.name}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex flex-column align-items-center gap-2 mt-4 mb-4">
                        <a
                            href={`https://wa.me/?text=${encodeURIComponent(
                                `Check out this amazing product from ${COMPANY_NAME} — premium quality and great value!.\n\nProduct: *${product?.name}*\nView here: ${window.location.href}`
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-dark w-75"
                        >
                            <FontAwesomeIcon icon={faWhatsapp} className='me-2' /> Share via WhatsApp
                        </a>

                        {/*<button
                            className="btn btn-dark w-75"
                            type="button"
                            onClick={() => {
                                const message = encodeURIComponent(
                                    `Hello, I would like to enquire about the product: *${product?.name}*`
                                );
                                window.open(`https://wa.me/${COMPANY_WHATSAPP}?text=${message}`, "_blank");
                            }}
                        >
                            Enquire Now
                        </button>*/}

                        <NavLink className="btn btn-outline-secondary w-75" to="/products">
                            ← Back to All Products
                        </NavLink>

                    </div>

                </>
            )}
            {showFullscreen && (
                <div className="fullscreen-swiper-modal"
                    onClick={() => setShowFullscreen(false)}>
                    <div
                        className="modal-close-btn"
                        style={{ zIndex: 999999 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowFullscreen(false);
                            setThumbsSwiper(null);
                        }}>✕</div>

                    <div onClick={(e) => e.stopPropagation()}>
                        <Swiper
                            key={showFullscreen ? "open" : "closed"}
                            modules={[Navigation, Pagination, Thumbs]}
                            navigation
                            pagination={{ clickable: true }}
                            thumbs={{ swiper: thumbsSwiper }}
                            initialSlide={activeIndex}
                            className="mb-3"
                        >
                            {styleGroups[selectedGroup].map((style, index) => (
                                <SwiperSlide key={index}>
                                    <img
                                        src={style?.imageUrl || defaultImage}
                                        className="mx-auto d-block"
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>

                    {/* Thumbnails */}
                    <Swiper
                        modules={[Thumbs]}
                        watchSlidesProgress
                        onSwiper={setThumbsSwiper}
                        slidesPerView={5}
                        spaceBetween={10}
                    >
                        {productStyles.map((style, index) => (
                            <SwiperSlide key={index}>
                                <img
                                    src={style?.imageUrl || defaultImage}
                                    style={{
                                        border: index === activeIndex ? "2px solid #fff" : "2px solid transparent",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setActiveIndex(index)}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}

        </div>
    );
};
